export const initNavFooterMobile = () => {

    let mediaQuery = window.matchMedia(`(min-width: 992px)`);

    const menuItems = document.querySelectorAll('.footer__menu-right-item');
    menuItems.forEach(item => {
        const submenu = item.querySelector('div > ul, .footer__menu-panel');
        if (!submenu) return;

        function openMenu() {
            if (mediaQuery.matches) return;
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
            item.classList.add('open');
            // Optional: set aria-expanded if using
            const toggle = item.querySelector('.footer__menu-toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'true');
            submenu.removeAttribute('hidden');
        }

        function closeMenu() {
            submenu.style.maxHeight = '';
            item.classList.remove('open');
            const toggle = item.querySelector('.footer__menu-toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            submenu.setAttribute('hidden', '');
        }

		function toggleMenu(e) {
            // Only on mobile
            if (mediaQuery.matches) return;
            // Only toggle if clicking directly on the item, not its children
            if (e.target !== item) return;
            e.preventDefault();
            const isOpen = item.classList.contains('open');
            menuItems.forEach(i => {
                const sub = i.querySelector('div > ul');
                if (sub) {
                    sub.style.maxHeight = '';
                    i.classList.remove('open');
                }
            });
            if (!isOpen) {
                submenu.style.maxHeight = submenu.scrollHeight + 'px';
                item.classList.add('open');
            }
        }


        // Open on focus in, close on focus out
        item.addEventListener('focusin', openMenu);
        item.addEventListener('focusout', (e) => {
            // Only close if focus moves outside the item
            if (mediaQuery.matches) return;
            if (!item.contains(e.relatedTarget)) {
                closeMenu();
            }
        });

		item.addEventListener('click', toggleMenu);

	// Handle open/close on resize
	function handleResize() {
		if (mediaQuery.matches) {
			// Desktop: open and show submenu
			submenu.style.maxHeight = '';
			item.classList.add('open');
			submenu.removeAttribute('hidden');
			const toggle = item.querySelector('.footer__menu-toggle');
			if (toggle) toggle.setAttribute('aria-expanded', 'true');
		} else {
			// Mobile: close and hide submenu
			submenu.style.maxHeight = '';
			item.classList.remove('open');
			submenu.setAttribute('hidden', '');
			const toggle = item.querySelector('.footer__menu-toggle');
			if (toggle) toggle.setAttribute('aria-expanded', 'false');
		}
	}

	// Initial state
	handleResize();

	// Listen for breakpoint changes
	mediaQuery.addEventListener('change', handleResize);
    });
}